import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from './en.json';
import fr from './fr.json'; // example for French

i18n
  .use(LanguageDetector) // detects browser language
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources: {
      en: { translation: en },
      fr: { translation: fr },
    },
    lng: 'en', // Set the default language
    fallbackLng: 'en', // Fallback language in case of missing translations
    debug: false,

    interpolation: {
      escapeValue: false, // React already does escaping
    },
  });

export default i18n;